const env = import.meta.env;

export async function getAuthToken(fbToken: string, stsEndpoint?: string | null) {
    const apiEndpoint = stsEndpoint ?? env.VITE_AUTH_API_ENDPOINT;
    const url = new URL(`${apiEndpoint}/auth/token`);

    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${fbToken}`,
        },
    });

    if (!response.ok) {
        throw new Error("Failed to fetch token");
    }

    const { token } = await response.json();

    return token;
}
